module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ThinItalic.3b825889.woff";